import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '../stores/auth.store';
import { APP_ROUTES } from '../constants/app-routes.const';

/**
 * 🛡️ Guest Guard (Chỉ cho phép khách - Chưa đăng nhập truy cập)
 * - Nếu người dùng ĐÃ đăng nhập: Tự động chuyển hướng về trang chủ
 * - Nếu người dùng CHƯA đăng nhập: Cho phép truy cập (Ví dụ: vào trang Login)
 */
export const guestGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  const router = inject(Router);

  // Chỉ redirect khi session đã bootstrap xong.
  // Nếu token còn nhưng load profile/menu thất bại (ví dụ /users/me sai endpoint),
  // cho phép vào trang login để tránh vòng lặp /login -> / -> guard -> /login.
  if (store.isAuthenticated() && store.isLoaded()) {
    router.navigate(['/' + APP_ROUTES.ROOT]).then();
    return false;
  }

  return true;
};
